module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Stainless Steel + Lemon Cream Open.0226c461.png";